import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=16c192e9&"
import script from "./orderList.vue?vue&type=script&lang=js&"
export * from "./orderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports